<template>
    <div>
      <overtime-work-type-list></overtime-work-type-list>
    </div>
  </template>
  
  <script>
  
  export default {
  }
  </script>
  
  
  